export default "__VITE_ASSET__7bWoH3P3__"